import { render } from "./DeletePlanModal.vue?vue&type=template&id=4396aaf8"
import script from "./DeletePlanModal.vue?vue&type=script&lang=js"
export * from "./DeletePlanModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__